// Wrap window.location reads/writes in a module so we can readily mock it in tests
// (jsdom 30 locks `window.location`, so it can no longer be mocked directly — see jsdom/jsdom#3492).

export const getWindowLocationHost = () => window.location.host

export const getWindowLocationHostname = () =>
  typeof window !== "undefined" ? window.location.hostname : ""

export const getWindowLocationHref = () => window.location.href

export const getWindowLocationPathname = () => window.location.pathname

export const getWindowLocationSearch = () => window.location.search

export const navigateWindowLocation = (href: string) => window.location.assign(href)

export const reloadWindowLocation = () => window.location.reload()

export const setWindowLocationPathname = (pathname: string) => {
  window.location.pathname = pathname
}
